import { Navigate, useLocation } from "react-router";

import { useEvaluation } from "@/hooks/useEvaluation/useEvaluation";
import { EvaluationCreateForm } from "../EvaluationCreateForm";

import { getRevieweeUserId } from "./EvaluationNew.utils";

import { SCORECARDS_ROUTE } from "@/constants/routes.constants";
import { redirectToDashboard } from "@/helpers/navigation/navigation.helpers";
import { useCall } from "@/hooks/useCall/useCall";
import { useGetScorecardByID } from "@/hooks/useGetScorecardByID/useGetScorecardByID";
import { useHasCcAccess } from "@/hooks/useHasCcAccess/useHasCcAccess";

export type ScoreCardLocationState = {
  scoreCardId?: string;
};

function EvaluationNewContent({ scoreCardId }: { scoreCardId: string }) {
  const { call } = useCall();

  const { scorecard, loading } = useGetScorecardByID({ ID: scoreCardId });

  const revieweeUserId = getRevieweeUserId(call);

  /**
   * If call data is not available, we redirect the user to /conversations page
   */
  if (!call || !revieweeUserId || (!scorecard && !loading)) {
    redirectToDashboard(SCORECARDS_ROUTE);
    return;
  }

  return scorecard && call && revieweeUserId ? (
    <EvaluationCreateForm
      transcriptionId={call?.transcription?.transcriptionId}
      revieweeUserId={revieweeUserId}
      scoreCard={scorecard}
    />
  ) : null;
}

export function EvaluationNew() {
  const hasCcAccess = useHasCcAccess();
  const { call } = useCall();

  const { evaluation, loading: evaluationLoading } = useEvaluation(call?.id);

  const location = useLocation();
  const { scoreCardId } = (location.state ?? {}) as ScoreCardLocationState;

  if (!hasCcAccess || !scoreCardId || (!evaluationLoading && evaluation)) {
    // direct to the main route `/calls/:callId/evaluation`
    return <Navigate to="../" />;
  }

  return (
    <EvaluationNewContent scoreCardId={scoreCardId}></EvaluationNewContent>
  );
}
